export var IQueryKey;
(function (IQueryKey) {
    IQueryKey["NEWS"] = "news";
    IQueryKey["NEWS_BANNER"] = "news banner";
})(IQueryKey || (IQueryKey = {}));
